import React from "react";
import TimeWindows from "../../../../../components/time-windows/TimeWindows";
import { getFeatureFlag } from "../../../../../services-logic/base-logic";

const KnowledgeBaseOpeningHourItem = ({ item, onUpdateKnowledgeItem }) => {
  const interval = parseInt(getFeatureFlag("SR-SNIPPET", "Organization.Snippet.openingHoursInterval", 30));

  return (
    <div className="w-full flex flex-col gap-4">
      <TimeWindows
        minRows={1}
        timeWindows={item.value}
        setTimeWindows={(value) => onUpdateKnowledgeItem("value", value)}
        interval={interval}
      />
    </div>
  );
};

export default KnowledgeBaseOpeningHourItem;
